export default "__VITE_ASSET__BZlCqcDa__"